import type {LogService} from 'core/logging/log.service';
import type {ClientSessionVerifierDataService} from './data-services/client-session-verifier.data-service';
import {load} from '@fingerprintjs/botd';

/*@ngInject*/
export function clientSideBotDetection(clientSessionVerifierDataService: ClientSessionVerifierDataService, logService: LogService) {
    load({monitoring: false})// disable 3rd party telemetry
        .then((botDetector) => botDetector.detect())
        .then((result) => clientSessionVerifierDataService.verify(result))
        .catch((error) => logService.error(error));
}